import { put, takeLatest, call } from 'redux-saga/effects';
import { POST } from '../consts/Methods';
import { RESET_PASSWORD, RESET_PASSWORD_FAIL, RESET_PASSWORD_SUCCESS } from '../redux/authReducer';
import apiCall from '../helpers/ApiCall';

function* ResetPasswordFlow({ payload: { password, token, }, }) {
  try {
    const endpoint = '/dealers/auth/update_password';
    const params = { dealer: { password, token, }, };
    yield call(apiCall, { endpoint, method: POST, params, });
    yield put(RESET_PASSWORD_SUCCESS())
  } catch (error) {
    yield put(RESET_PASSWORD_FAIL(error));
  }
}

export default function* ResetPassword() {
  yield takeLatest(RESET_PASSWORD, ResetPasswordFlow);
}
